import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
    {
        id: "po-04-h3v1-01",
        name: "PO 01 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 94, y: 96, width: 427, height: 684, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 0, width: 386, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 295, width: 386, height: 286, rotation: 0, imageRotation: 0 },
            { id: "4", x: 783, y: 589, width: 386, height: 286, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-02",
        name: "PO 02 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 56, y: 63, width: 478, height: 767, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 63, width: 355, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 322, width: 355, height: 251, rotation: 0, imageRotation: 0 },
            { id: "4", x: 841, y: 581, width: 355, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-03",
        name: "PO 03 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 118, y: 63, width: 355, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 322, width: 355, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 118, y: 581, width: 355, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 63, width: 478, height: 767, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-04",
        name: "PO 04 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 78, y: 197, width: 456, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 511, width: 224, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 309, y: 511, width: 225, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 684, y: 62, width: 468, height: 750, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-05",
        name: "PO 05 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 78, y: 197, width: 224, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 197, width: 225, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 78, y: 372, width: 456, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 768, y: 197, width: 301, height: 482, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-06",
        name: "PO 06 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 52, y: 183, width: 523, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 542, width: 258, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 542, width: 257, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 1, width: 625, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-07",
        name: "PO 07 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 74, y: 63, width: 478, height: 767, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 379, width: 466, height: 314, rotation: 0, imageRotation: 0 },
            { id: "3", x: 942, y: 200, width: 230, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 706, y: 200, width: 230, height: 172, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-08",
        name: "PO 08 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 190, width: 307, height: 253, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 451, width: 307, height: 253, rotation: 0, imageRotation: 0 },
            { id: "3", x: 314, y: 190, width: 621, height: 512, rotation: 0, imageRotation: 0 },
            { id: "4", x: 944, y: 190, width: 307, height: 512, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-09",
        name: "PO 09 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 52, y: 61, width: 456, height: 772, rotation: 0, imageRotation: 0 },
            { id: "2", x: 514, y: 594, width: 340, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 514, y: 61, width: 687, height: 525, rotation: 0, imageRotation: 0 },
            { id: "4", x: 861, y: 594, width: 340, height: 239, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-10",
        name: "PO 10 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 191, y: 84, width: 271, height: 411, rotation: 0, imageRotation: 0 },
            { id: "2", x: 191, y: 503, width: 431, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 84, width: 592, height: 411, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 503, width: 431, height: 309, rotation: 0, imageRotation: 0 }
        ],
    }
];